import { Injectable } from '@angular/core';
import { DashboardCollaudi } from '../model/DashboardCollaudi';
import { DashboardDocument } from '../model/DashboardDocument';
import { DASHBOARD_DOCUMENTS, DASHBOARD_SVINCOLI } from '../model/DashboardMock';
import { DashboardSvincoli } from '../model/DashboardSvincoli';
import { IDashBoardService } from './IDashBoardService';

@Injectable(
  {providedIn: 'root'}
)
export class DashboardService implements IDashBoardService {

  constructor() { }
  
  getNumeroNotificheOrdini(): Promise<number> {
    throw new Error('Method not implemented.');
  }
  getNumeroNotificheSvincoli(): Promise<number> {
    throw new Error('Method not implemented.');
  }
  getNumeroNotificheNonConformita(): Promise<number> {
    throw new Error('Method not implemented.');
  }
    
  getCollaudi(): Promise<DashboardCollaudi[]> {
    throw new Error('Method not implemented.');
  }

  getDocumenti(): Promise<DashboardDocument[]> {
    return new Promise(resolve =>
      setTimeout(() => resolve(DASHBOARD_DOCUMENTS), 1000)
    );
  }

  getSvincoli(): Promise<DashboardSvincoli[]> {
    return new Promise(resolve =>
      setTimeout(() => resolve(DASHBOARD_SVINCOLI), 1000)
    );
  }
}
